const getSubworkstreamCatagory = (initiative, subworkstream) => {
    if (!initiative || !initiative.impact || initiative.impact.length === 0 || !Array.isArray(subworkstream)) {
      return [];
    }
  
    const subworkstreamNames = [];
    const seenSubworkstreamNames = new Set();
  
    for (const impactItem of initiative.impact) {
      if (impactItem.workstream) {
        const subwork = subworkstream.find(
          (sub) => sub._id === impactItem.workstream
        );
        if (subwork && subwork.subworkstreamName && !seenSubworkstreamNames.has(subwork.subworkstreamName)) {
          subworkstreamNames.push(subwork.subworkstreamName);
          seenSubworkstreamNames.add(subwork.subworkstreamName);
        }
      }
    }
    return subworkstreamNames;
  };
  export default getSubworkstreamCatagory;